<!-- @format -->

<ng-container *transloco="let t">
  @if (showClassificationInfo) {
    <sis-description-list>
      @if (isDegreeProgramme(_module) && _module.degreeLanguageUrns?.length > 0) {
        <ng-template #listItem>
          <dt>{{ t("MODULE_INFO.TITLE_DEGREE_LANGUAGES") }}</dt>
          @for (degreeLanguageUrn of _module.degreeLanguageUrns; track degreeLanguageUrn) {
            <dd>{{ degreeLanguageUrn | codeLocalizedName | async }}</dd>
          }
        </ng-template>
      }
      @if (isDegreeProgramme(_module) && _module.degreeTitleUrns?.length > 0) {
        <ng-template #listItem>
          <dt>{{ t("MODULE_INFO.TITLE_DEGREE_TITLES") }}</dt>
          @for (degreeTitleUrn of _module.degreeTitleUrns; track degreeTitleUrn) {
            <dd>{{ degreeTitleUrn | codeLocalizedName | async }}</dd>
          }
        </ng-template>
      }
      @if (isStudyModule(_module) && _module?.possibleAttainmentLanguages?.length > 0) {
        <ng-template #listItem>
          <dt>{{ t("MODULE_INFO.TITLE_STUDY_MODULE_LANGUAGES") }}</dt>
          @for (attainmentLanguageUrn of _module.possibleAttainmentLanguages; track attainmentLanguageUrn) {
            <dd>{{ attainmentLanguageUrn | codeLocalizedName | async }}</dd>
          }
        </ng-template>
      }
      @if (_module?.studyFields?.length > 0) {
        <ng-template #listItem>
          <dt>{{ t("MODULE_INFO.STUDY_FIELDS") }}</dt>
          @for (studyFieldUrn of _module.studyFields; track studyFieldUrn) {
            <dd>{{ studyFieldUrn | codeLocalizedName | async }}</dd>
          }
        </ng-template>
      }
    </sis-description-list>
  } @else {
    <p>{{ t("MODULE_INFO.NO_INFORMATION_GIVEN") }}</p>
  }
</ng-container>
